import { RadioField, RadioFieldProps } from 'components/FormFields'
import { useField } from 'formik'
import React from 'react'
import styled, { css } from 'styled-components'
import { FormikFieldStatus } from '../../Formik.field.status'

export const formikRadioStyles = css``

const FormikRadioView = styled.div`
	${formikRadioStyles}
`

export type FormikRadioProps = Pick<
	RadioFieldProps<string | number>,
	'options' | 'className' | 'defaultVal'
> & {
	name: string
	config: Pick<
		RadioFieldProps<string | number>,
		'isReq' | 'label' | 'spaceBottom' | 'spaceRight' | 'labelPos' | 'displayType'
	>
}

export const FormikRadio = ({ name, className, config, ...props }: FormikRadioProps) => {
	const [{ value }, { touched }, { setValue, setTouched }] = useField({ name })
	return (
		<FormikRadioView className={`formik-radio${className ? ` ${className}` : ''}`}>
			<RadioField
				{...props}
				{...config}
				name={name}
				defaultVal={value}
				onChange={(val: any) => {
					setValue(val)
					if (!touched) setTouched(true)
				}}
			/>
			<FormikFieldStatus name={name} />
		</FormikRadioView>
	)
}
